import React from "react";
import { StyleSize } from "../../common/models";

interface Props {
  title: string;
  className?: string;
  size?: StyleSize;
}

const Title: React.FC<Props> = ({
  title,
  className,
  size = "default",
}): React.ReactElement => {
  return <div className={`Title ${size} ${className ?? ""}`}>{title}</div>;
};

export default Title;
